import React, {useEffect, useState} from 'react';
import DynaModal from "../../../../Modal/DynaModal";
import DynaInput from "../../../DynaView/DynaInput";
import DynaSelectBox from "../../../DynaView/DynaSelectBox";
import DynaTextarea from "../../../DynaView/DynaTextarea";
import _axios from "../../../../../httpService";
import {prefixUrl} from "../../../../../utils/utilsData";
import {toast} from "react-toastify";

const ModalEditLead = ({onClose, data, setReRender}) => {

  const [isLoad, setIsLoad] = useState(false)
  const [initialData, setInitialData] = useState({})
  const [sendData, setSendData] = useState({
    leadId: "",
    mobile: "",
    full_name: "",
    group: "کارواش",
    active_status: "",
    province: "",
    city: "",
    lead_cost: "",
    telephone: "",
    instagram: "",
    website: "",
    description: "",
    newProvince: 0
  });
  const [cities, setCities] = useState([]);
  const [errorMessage, setErrorMessage] = useState("")

  useEffect(() => {
    setInitialData(data?.distinctValues)
    setSendData({...data?.formData, newProvince: 0})
    const filtered = data?.distinctValues?.province.filter((item) => {
      return item?.value === data?.formData?.province
    })
    if (filtered.length > 0) {
      setCities(filtered[0].cities)
    } else {
      setCities([])
    }
    setIsLoad(true)
  }, []);

  const modalDataHandle = () => {

    const formData = new FormData();
    let isValid = true

    if (sendData?.full_name === "" || sendData?.mobile === "" || sendData?.group === "" || sendData?.active_status === "" || sendData?.province === "" || sendData?.city === "") {
      isValid = false
    }

    Object.keys(sendData).forEach((key) => {
      formData.append(key, sendData[key]);
    });

    if (isValid) {
      _axios.post(prefixUrl() + "/sadenMarketingCRM/?request=editSubmittedLeadData", formData).then((response) => {
        if (response.data.status) {
          toast.success(response.data.message)
          onClose()
          setReRender(Math.random() * 13)
        } else {
          toast.error(response.data.message)
        }
      })
    } else {
      setErrorMessage("اطلاعات را کامل وارد کنید")
    }
  }

  useEffect(() => {
    if (sendData?.leadId !== "") {
      if (sendData?.province === "") {
        setSendData({...sendData, city: ""})
      } else {
        const filtered = initialData?.province.filter((item) => {
          return item?.value === sendData?.province
        })
        if (filtered.length > 0) {
          setCities(filtered[0].cities)
        } else {
          setCities([])
        }
      }
    }
  }, [sendData?.province]);

  useEffect(() => {
    if (sendData?.newProvince !== 0) {
      setSendData({...sendData, city: ""})
    }
  }, [sendData?.newProvince]);

  return (
    <DynaModal onClose={onClose} className={'simple-modal-saden'}>
      <div className="header-modal">
        <p>لید</p>

        <div onClick={onClose}>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M9.16936 15.5801C8.97936 15.5801 8.78938 15.5101 8.63938 15.3601C8.34938 15.0701 8.34938 14.5901 8.63938 14.3001L14.2994 8.64011C14.5894 8.35011 15.0694 8.35011 15.3594 8.64011C15.6494 8.93011 15.6494 9.41011 15.3594 9.70011L9.69936 15.3601C9.55936 15.5101 9.35936 15.5801 9.16936 15.5801Z"
              fill="white"/>
            <path
              d="M14.8294 15.5801C14.6394 15.5801 14.4494 15.5101 14.2994 15.3601L8.63938 9.70011C8.34938 9.41011 8.34938 8.93011 8.63938 8.64011C8.92937 8.35011 9.40936 8.35011 9.69936 8.64011L15.3594 14.3001C15.6494 14.5901 15.6494 15.0701 15.3594 15.3601C15.2094 15.5101 15.0194 15.5801 14.8294 15.5801Z"
              fill="white"/>
            <path
              d="M15 22.75H9C3.57 22.75 1.25 20.43 1.25 15V9C1.25 3.57 3.57 1.25 9 1.25H15C20.43 1.25 22.75 3.57 22.75 9V15C22.75 20.43 20.43 22.75 15 22.75ZM9 2.75C4.39 2.75 2.75 4.39 2.75 9V15C2.75 19.61 4.39 21.25 9 21.25H15C19.61 21.25 21.25 19.61 21.25 15V9C21.25 4.39 19.61 2.75 15 2.75H9Z"
              fill="white"/>
          </svg>
        </div>
      </div>

      {isLoad &&
        <div className="form-content-modal">
          <DynaInput label={"شماره موبایل"}
                     name={"mobile"}
                     className={"solid-dyna-input"}
                     placeholder={"شماره موبایل را وارد کنید"}
                     value={sendData?.mobile}
                     type={"number"}
                     setDataFromComponent={(data) => {
                       setSendData({...sendData, ...data})
                     }}
          />
          <DynaInput label={"نام و نام خانوادگی"}
                     name={"full_name"}
                     className={"solid-dyna-input"}
                     placeholder={"نام و نام خانوادگی را وارد کنید"}
                     value={sendData?.full_name}
                     type={"text"}
                     setDataFromComponent={(data) => {
                       setSendData({...sendData, ...data})
                     }}
          />
          <DynaSelectBox options={initialData?.group}
                         hasFilter={true}
                         label={"انتخاب گروه"}
                         className={"solid-dyna-input"}
                         value={sendData?.group}
                         onChange={(data) => setSendData({
                           ...sendData,
                           group: data.value,
                         })}
          />
          <DynaSelectBox options={initialData?.activeStatus}
                         hasFilter={true}
                         label={"وضعیت فعال"}
                         className={"solid-dyna-input"}
                         value={sendData?.active_status}
                         onChange={(data) => setSendData({
                           ...sendData,
                           active_status: data.value,
                         })}
          />
          <DynaSelectBox options={initialData?.province}
                         hasFilter={true}
                         label={"استان"}
                         className={"solid-dyna-input"}
                         value={sendData?.province}
                         onChange={(data) => setSendData({
                           ...sendData,
                           province: data.value,
                           newProvince: Math.random() * 13
                         })}
          />
          <DynaSelectBox options={cities}
                         hasFilter={true}
                         label={"شهر"}
                         className={"solid-dyna-input"}
                         value={sendData?.city}
                         onChange={(data) => setSendData({
                           ...sendData,
                           city: data.value,
                         })}
          />
          <DynaInput label={"هزینه لید"}
                     name={"lead_cost"}
                     className={"solid-dyna-input"}
                     placeholder={"هزینه لید را وارد کنید"}
                     value={sendData?.lead_cost}
                     type={"text"}
                     setDataFromComponent={(data) => {
                       setSendData({...sendData, ...data})
                     }}
          />
          <DynaInput label={"تلفن"}
                     name={"telephone"}
                     className={"solid-dyna-input"}
                     placeholder={"تلفن را وارد کنید"}
                     value={sendData?.telephone}
                     type={"text"}
                     setDataFromComponent={(data) => {
                       setSendData({...sendData, ...data})
                     }}
          />
          <DynaInput label={"اینستاگرام"}
                     name={"instagram"}
                     className={"solid-dyna-input"}
                     placeholder={"اینستاگرام را وارد کنید"}
                     value={sendData?.instagram}
                     type={"text"}
                     setDataFromComponent={(data) => {
                       setSendData({...sendData, ...data})
                     }}
          />
          <DynaInput label={"وب سایت"}
                     name={"website"}
                     className={"solid-dyna-input"}
                     placeholder={"وب سایت را وارد کنید"}
                     value={sendData?.website}
                     type={"text"}
                     setDataFromComponent={(data) => {
                       setSendData({...sendData, ...data})
                     }}
          />
          <div style={{gridColumn: "1/-1"}}>
            <DynaTextarea label={"توضیحات"}
                          name={"description"}
                          style={{height: '100px'}}
                          className={"solid-dyna-input"}
                          placeholder={"توضیحات را وارد کنید"}
                          value={sendData?.description}
                          type={"text"}
                          setDataFromComponent={(data) => {
                            setSendData({...sendData, ...data})
                          }}
            />
            <h5 className={"show-error-message"}>{errorMessage}</h5>
            <div className="button-modal">
              <button onClick={onClose} className="cancel-saden-modal">انصراف</button>
              <button className="accept-saden-modal" onClick={modalDataHandle}>ثبت</button>
            </div>
          </div>
        </div>
      }
    </DynaModal>
  );
};

export default ModalEditLead;